import script from "./ExpendituresPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpendituresPage.vue?vue&type=script&setup=true&lang=js"

import "./ExpendituresPage.vue?vue&type=style&index=0&id=230cb2e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230cb2e1"]])

export default __exports__